import { createSelector } from "@reduxjs/toolkit";
import { pickupLocationsByIdSelector, storeSelector } from "../store/selectors";
import { DELIVERY_ADDRESS, DELIVERY_PICKUP } from "./reducer";

export const deliverySelector = (state) => state.delivery;

export const deliveryAvailableSelector = createSelector(
  deliverySelector,
  pickupLocationsByIdSelector,
  storeSelector,
  (delivery, pickupLocations, store) =>
    store.deliveryTypes.includes(delivery.type) &&
    ((delivery.type === DELIVERY_ADDRESS &&
      Boolean(delivery.address) &&
      typeof delivery.cost === "number" &&
      Number.isFinite(delivery.cost) &&
      delivery.cost >= 0) ||
      (delivery.type === DELIVERY_PICKUP &&
        Boolean(pickupLocations[delivery.pickup_location_id])))
);

export const pickupLocationSelector = createSelector(
  deliverySelector,
  pickupLocationsByIdSelector,
  (self, pickupLocations) => pickupLocations[self.pickup_location_id]
);

export const isAddressDeliverySelector = createSelector(
  deliverySelector,
  (delivery) => delivery.type === DELIVERY_ADDRESS
);
